// Add frame to cart with art print
document.addEventListener('submit', e => {
  const form = e.target;
  const checkbox = document.querySelector('#frame-checkbox:checked');
  const frameData = document.querySelector('[data-frame-variant]');

  if (!checkbox || !frameData) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const frame = JSON.parse(frameData.textContent);
  const formData = new FormData(form);
  const qty = formData.get('quantity') || '1';

  // Prepare bundled sections like the theme does
  let sections = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections }
  }));

  formData.delete('id');
  formData.delete('quantity');
  formData.append('items[0][id]', form.id.value);
  formData.append('items[0][quantity]', qty);
  formData.append('items[1][id]', frame.id);
  formData.append('items[1][quantity]', qty);

  if (sections.length) {
    formData.set('sections', sections.join(','));
  }

  fetch(form.action, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    }
  })
    .then(r => r.json())
    .then(data => {
      return fetch('/cart.js').then(r => r.json()).then(cart => {
        cart.sections = data.sections;
        return cart;
      });
    })
    .then(cart => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart, baseEvent: 'variant:add' }
      }));
    })
    .catch(err => console.error('Frame addon error:', err));
}, true);
